/**
 * @fileoverview Agent definition for next-chapter-suggester-v2.
 *
 * Suggests three distinct options for the NEXT UNWRITTEN chapter,
 * continuing directly from where the last written chapter ends.
 *
 * This agent is scoped to a single chapter and anchors to the
 * current writing position, not the end of the plot outline.
 *
 * @category narrative.chapters.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'next-chapter-suggester-v2',
  kind: 'primitive',
  name: 'Next Chapter Suggester',
  description: 'Suggests three distinct options for the next unwritten chapter, continuing directly from the last written chapter.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'narrative.chapters.planning',
    usedBy: [
      'primitives/use-next-chapter-suggester-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-planner-v2',
      'plot-snapshotter-v2',
    ],
  },
};
